import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../../PaginatedFetchTable';
import Avatar from '../../Avatar';
import ConfirmedAsyncFunctionTrigger from '../../ConfirmedAsyncFunctionTrigger';
import ModalTrigger from '../../ModalTrigger';
import DateTimeDisplay from '../../DateTimeDisplay';


export default class StaffFeedbacksRequestedList extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    timestampFormat: PropTypes.string,
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    timestampFormat: 'MMMM D [at] h:mm A z',
    timezone: moment.tz.guess(),
    defaultSort: null,
    apiUrl: '',
  }

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <a href={item.about.staff_url}>
          <div className="u-flex u-items-center">
            {item.about.type !== 'event' && (
            <Avatar
              className="StaffTable-avatar u-mr-2"
              src={item.about.avatar_url}
              type={item.about.type}
              showInitials
              name={item.about.name}
                />
            )}
            <div className="u-font-semibold u-truncate">
              {item.about.name}
            </div>
          </div>
        </a>
      </td>
      <td>
        <a href={item.author.staff_url}>
          <div className="u-flex u-items-center">
            <Avatar
              className="StaffTable-avatar u-mr-2 "
              src={item.author.avatar_url}
              type="user"
              showInitials
              name={item.author.name}
                />
            <div className="u-font-semibold u-truncate">
              {item.author.name}
            </div>
          </div>
        </a>
      </td>
      {item.about.type !== 'event' && (
        <td>
          {item.source && (
          <a className="u-truncate u-font-semibold u-block" href={item.source.staff_url}>{item.source.name}</a>
          )}
        </td>
      )}
      <td>
        <DateTimeDisplay useTimezone={this.props.timezone} timestamp={item.trigger_at} date_only />
      </td>
      <td>
        <span title={moment(item.expires_in_timestamp).tz(this.props.timezone).format(this.props.timestampFormat)}>
          {item.expires_in}
        </span>
      </td>
      <td className="actions">
        <ModalTrigger
          async
          asyncUrl={item.remind_url}
          triggerClassName="Button u-mr-2"
          triggerIcon="Icon Icon-email-digests"
          triggerIconClassName="u-mr-0"
          />
        <ConfirmedAsyncFunctionTrigger
          method="delete"
          url={item.dismiss_url}
          triggerLabel=""
          triggerIcon="Icon-delete"
          triggerIconExtraClassName=""
          triggerClassName="Button Button--red"
          triggerExtraClassName=""
          buttonConfirmLabel="Yes, delete feedback request"
          buttonConfirmClassName="Button--primary Button--red"
          buttonCancelClassName="Button Button--grey"
          modalHeader="Delete feedback request?"
          modalBody="Are you sure you want to delete this feedback request? This is not something you can undo."
          />
      </td>
    </tr>
  )

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow}
      />
    );
  }
}
